import type { RouteObject } from 'react-router-dom';
import { Suspense } from 'react';

import { HomePage } from '@/pages/home';
import { NotFoundPage } from '@/pages/not-found';
import { LoginPage } from '@/pages/login';
import { OAuthCallbackPage } from '@/pages/oauth-callback';

import { StorageOverviewPage } from '@/pages/dashboard/storage-overview';
import { TransportOverviewPage } from '@/pages/dashboard/transport-overview';
import { ServiceUsersPage } from '@/pages/dashboard/service-users';
import { MappingPage } from '@/pages/dashboard/mapping';

import { PrivateLayout } from '@/widgets/private-layout';

import { RouteNames } from '@/shared/config/routes';
import { AuthGuard } from '@/shared/lib';

export const publicRoutes: RouteObject[] = [
  {
    path: RouteNames.LOGIN,
    element: (
      <AuthGuard requireAuth={false}>
        <LoginPage />
      </AuthGuard>
    )
  },
  {
    element: <OAuthCallbackPage />,
    children: [
      {
        path: RouteNames.AZURE_CALLBACK
      },
      {
        path: RouteNames.CIAM_CALLBACK
      }
    ]
  },
  {
    path: RouteNames.NOT_FOUND,
    element: <NotFoundPage />
  }
];

export const privateRoutes: RouteObject[] = [
  {
    element: (
      <AuthGuard requireAuth={true}>
        <PrivateLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: RouteNames.HOME,
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <HomePage />
          </Suspense>
        )
      },
      {
        path: RouteNames.DASHBOARD_STORAGE,
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <StorageOverviewPage />
          </Suspense>
        )
      },
      {
        path: RouteNames.DASHBOARD_TRANSPORT,
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <TransportOverviewPage />
          </Suspense>
        )
      },
      {
        path: RouteNames.DASHBOARD_SERVICE_USERS,
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <ServiceUsersPage />
          </Suspense>
        )
      },
      {
        path: RouteNames.DASHBOARD_MAPPING,
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <MappingPage />
          </Suspense>
        )
      }
    ]
  }
];
